import {
  DOCS_URLS,
  useNavigateWithSearchParams,
  useUser,
} from "@p0security/frontend-core";
import { Button, Col, Flex, Spacing, Typography } from "@p0security/ui";
import { Admin } from "components/Admin/Admin";
import React, { useCallback } from "react";
import { Link, useParams } from "react-router-dom";
import { spacing } from "styles/spacing";

import { AllIntegrationLogos } from "../../Integrations/IntegrationLogo.tsx";
import { Splash } from "../../Splash";
import { SkipOnboardingButton } from "../components/SkipOnboardingButton";
import { useFlow } from "../hooks/useFlow";
import { WelcomePaths } from "../paths";
import { SupportedCloudProviders } from "../types";

const ConfigureApprovers = React.memo(() => {
  const { cloudProvider } = useParams<{
    cloudProvider: SupportedCloudProviders;
  }>();

  const [flow] = useFlow();
  const navigateWithSearchParams = useNavigateWithSearchParams();
  const { orgSlug } = useUser();

  const handleContinue = useCallback(() => {
    navigateWithSearchParams(
      `/o/${orgSlug}/${WelcomePaths.Root}/${WelcomePaths.Onboarding}/${cloudProvider}/${flow === "jit" ? WelcomePaths.Notifiers : WelcomePaths.Success}`
    );
  }, [flow, navigateWithSearchParams, orgSlug, cloudProvider]);

  return (
    <Splash
      overrideColumn
      rowStyleOverride={{ alignItems: "center" }}
      onNext={handleContinue}
    >
      <Col xs={22} md={11} lg={8} xl={6}>
        <Flex align="center" gap={spacing.layout.grid.gap.xs}>
          <Spacing asChild m={0}>
            <Typography.Title level={4}>Install P0 for</Typography.Title>
          </Spacing>
          {cloudProvider && <>{AllIntegrationLogos[cloudProvider]}</>}
        </Flex>
        <Typography.Paragraph>
          {`Configure ${
            flow === "jit" ? "Just-in-time" : "IAM assessment"
          } access control for your cloud provider.`}
        </Typography.Paragraph>
        <Typography.Paragraph>
          You can find out more in our&nbsp;
          <Link to={DOCS_URLS.ACCESS_CONTROL} target="_blank" rel="noreferrer">
            official documentation
          </Link>
          .
        </Typography.Paragraph>
        <SkipOnboardingButton />
      </Col>
      <Col xs={22} md={12} lg={12} xl={10}>
        <Flex align="flex-end" className="flex-col">
          <Admin />
          <Spacing asChild mt={spacing.layout.grid.gap.sm}>
            <Button
              /* eslint-disable-line react/forbid-component-props */ style={{
                width: "8em",
              }}
              type="primary"
              onClick={handleContinue}
            >
              Next
            </Button>
          </Spacing>
        </Flex>
      </Col>
    </Splash>
  );
});

ConfigureApprovers.displayName = "ConfigureApprovers";

export { ConfigureApprovers };
